export class CookieConsent {
  analytics = false

  marketing = false

  constructor(analytics = false, marketing = false) {
    this.analytics = analytics === true
    this.marketing = marketing === true
  }

  static WithFullConsent() {
    return new CookieConsent(true, true)
  }

  static WithNoConsent() {
    return new CookieConsent(false, false)
  }

  clone() {
    return new CookieConsent(this.analytics, this.marketing)
  }

  isFullConsent() {
    return this.analytics && this.marketing
  }
}
